import React from "react"
import Sitejet from "../../../static/img/plesk/Plesk-SiteJet-1024x597.png"

const FeaturesSitejet = () => {
  return (
    <section className="bg-light">
      <div className="container-xl">
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="d-flex flex-column justify-content-center">
              <h3 className="mb-4 component-title text-dark-blue">
                Free Professional Website Builder
              </h3>
              <div className="description py-4">
                <div className="mb-3">
                  Benefit from our extensive CMS, save time using 120+ presets,
                  and drag-and-drop 100+ template segments on the fly. Use the
                  Advanced Code editor for CSS, JS, HTML.
                </div>
                <ul>
                  <li className="mb-2">
                    <i className="bi bi-patch-check-fill me-2"></i>Effortless
                    website creation
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-patch-check-fill me-2"></i>Built-in AI
                    Text Generator
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-patch-check-fill me-2"></i>Drag & drop
                    website builder
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-patch-check-fill me-2"></i>140+ website
                    templates
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-patch-check-fill me-2"></i>120+ section
                    templates
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-patch-check-fill me-2"></i>Responsive
                    settings (Flexbox)
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-patch-check-fill me-2"></i>Website
                    import & backups
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-patch-check-fill me-2"></i>Design
                    flexibility (HTML, CSS, JS)
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-patch-check-fill me-2"></i>SEO-friendly
                    websites
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-patch-check-fill me-2"></i>Free stock
                    photos & videos
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-patch-check-fill me-2"></i>Image Editing
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="d-flex justify-content-center d-none d-lg-block p-5">
              <img
                className="img-fluid"
                alt="Sitejet Website builder"
                src={Sitejet}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FeaturesSitejet
